/*
 * search-modal.js — Content-Suche im Overlay (Hybrid).
 *
 * Seiten:   clientseitiger Volltext-Index (assets/search-index.json), weil
 *           Shopifys native Suche Section-/Block-Inhalte NICHT durchsucht.
 *           Index wird per scripts/generate-search-index.mjs gebaut.
 * Magazin:  Shopify-Volltextsuche (/search?view=suggest-content) — Artikel-
 *           Inhalt liegt in article.content und ist nativ durchsuchbar.
 *
 * Öffnen:  document.dispatchEvent(new CustomEvent('search-modal:open'))
 */
(function () {
  'use strict';

  var modal = document.querySelector('[data-search-modal]');
  if (!modal) return;

  var INDEX_URL = modal.getAttribute('data-search-index-url') || '';
  var pageIndex = null;      // flache, durchsuchbare Liste (lazy aufgebaut)
  var indexLoading = false;

  // Echte Seitenliste (von Liquid gerendert: nur veröffentlichte Seiten, mit
  // echter URL/Titel/Template-Suffix). Liegt außerhalb des teleportierten Modals.
  var sitePages = [];
  (function () {
    var el = document.querySelector('[data-search-pages]');
    if (!el) return;
    try {
      var arr = JSON.parse(el.textContent);
      if (Array.isArray(arr)) sitePages = arr;
    } catch (e) { /* leer lassen — dann keine lokalen Seiten-Treffer */ }
  })();

  // Such-Aliase: { "<handle>": ["hilfe", …] } — Begriffe, die zur Seite führen,
  // ohne in Titel/Handle zu stehen. searchSites() behandelt einen Alias-Treffer
  // wie einen Titel-Treffer der zugehörigen Seite.
  var aliasByHandle = {};
  (function () {
    var el = document.querySelector('[data-search-aliases]');
    if (!el) return;
    try {
      var obj = JSON.parse(el.textContent);
      if (obj && typeof obj === 'object') {
        Object.keys(obj).forEach(function (h) {
          aliasByHandle[h] = (obj[h] || []).map(function (a) { return String(a).toLowerCase(); });
        });
      }
    } catch (e) { /* keine Aliase */ }
  })();

  var input        = modal.querySelector('[data-search-input]');
  var body         = modal.querySelector('[data-search-body]');
  var emptyEl      = modal.querySelector('[data-search-empty]');
  var loadingEl    = modal.querySelector('[data-search-loading]');
  var noResultsEl  = modal.querySelector('[data-search-noresults]');
  var resultsEl    = modal.querySelector('[data-search-results]');
  var sitesGroup   = modal.querySelector('[data-search-sites-group]');
  var sitesEl      = modal.querySelector('[data-search-sites]');
  var pagesGroup   = modal.querySelector('[data-search-pages-group]');
  var pagesEl      = modal.querySelector('[data-search-pages]');
  var articlesGroup = modal.querySelector('[data-search-articles-group]');
  var articlesEl   = modal.querySelector('[data-search-articles]');
  var allLink      = modal.querySelector('[data-search-all-link]');

  var ARTICLE_LIMIT = 5;
  var debounceTimer = null;
  var activeController = null;

  // ── Seiten-Index laden + zu flacher Suchliste auflösen (lazy) ────────────
  // Der Index ist nach Template-Suffix gruppiert ({ "<suffix>": [sections] }).
  // Verknüpfung mit den ECHTEN Seiten (sitePages): pro Seite × Section ihres
  // Templates ein Eintrag mit echter URL + Anker. So stimmen Handle/Titel immer,
  // Template-Sharing (mehrere Seiten, ein Template) wird korrekt aufgelöst, und
  // unveröffentlichte Seiten fehlen automatisch (sie sind nicht in sitePages).
  function loadIndex() {
    if (pageIndex !== null || indexLoading || !INDEX_URL) return;
    indexLoading = true;
    fetch(INDEX_URL)
      .then(function (res) { return res.json(); })
      .then(function (byTemplate) {
        pageIndex = [];
        if (byTemplate && typeof byTemplate === 'object') {
          sitePages.forEach(function (pg) {
            // Rechtliche/Compliance-Seiten erzeugen KEINE inhaltlichen Section-
            // Treffer (sonst rankt z.B. Cookie-Policy bei "kostenerstattung", weil
            // sie sich das Default-Template teilen). Sie bleiben nur in der
            // Seiten-Gruppe über einen echten Namens-/Alias-Treffer auffindbar.
            if (pg.legal) return;
            var sections = byTemplate[pg.suffix || ''];
            if (!sections) return;
            sections.forEach(function (s) {
              pageIndex.push({
                title: s.title || pg.title,
                page: pg.title,
                url: pg.url + s.anchor,
                text: s.text || '',
              });
            });
          });
        }
        var q = input && input.value.trim();
        if (q && q.length >= 2) runSearch(q);
      })
      .catch(function () { pageIndex = []; })
      .finally(function () { indexLoading = false; });
  }

  // ── Modal öffnen/schließen ───────────────────────────────────────────────
  function openModal() {
    document.body.classList.add('searchmodal-active');
    loadIndex();
    if (typeof syncClear === 'function') syncClear();
    // Fokus nach dem Reflow setzen, damit das Eingabefeld zuverlässig anspringt.
    requestAnimationFrame(function () {
      if (input) { input.focus(); input.select(); }
    });
  }

  function closeModal() {
    document.body.classList.remove('searchmodal-active');
  }

  document.addEventListener('search-modal:open', openModal);

  modal.querySelectorAll('[data-search-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  // Klick auf einen Treffer schließt das Overlay (sonst bleibt body:overflow-hidden
  // aktiv und verdeckt das Ziel — kritisch beim Same-Page-Hash-Sprung, wo kein
  // Page-Load das Overlay zurücksetzt). Delegiert, weil Treffer dynamisch sind.
  modal.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link || !modal.contains(link)) return;
    closeModal();

    // Same-Page-Treffer: Ziel-Seite = aktuelle Seite, nur der Hash ändert sich.
    // Zeigt der Link exakt auf den schon aktiven Hash, feuert kein hashchange →
    // wir stoßen die Hash-Handler manuell an, damit trotzdem gescrollt wird.
    var url = link.getAttribute('href') || '';
    var hashIdx = url.indexOf('#');
    if (hashIdx === -1) return;
    var path = url.slice(0, hashIdx) || window.location.pathname;
    var newHash = url.slice(hashIdx); // inkl. '#'
    var samePage = path === window.location.pathname || path === '';
    if (samePage && newHash === window.location.hash) {
      // Hash ist identisch → hashchange bleibt aus. Kurz verzögert dispatchen,
      // damit das Overlay-Schließen (overflow zurück) zuerst greift.
      setTimeout(function () {
        window.dispatchEvent(new HashChangeEvent('hashchange'));
      }, 30);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.body.classList.contains('searchmodal-active')) {
      closeModal();
    }
  });

  // ── Zustände umschalten ──────────────────────────────────────────────────
  function showState(state) {
    if (emptyEl)     emptyEl.style.display     = state === 'empty' ? '' : 'none';
    if (loadingEl)   loadingEl.style.display   = state === 'loading' ? 'flex' : 'none';
    if (noResultsEl) noResultsEl.style.display = state === 'noresults' ? '' : 'none';
    if (resultsEl)   resultsEl.style.display   = state === 'results' ? '' : 'none';
  }

  // ── Vorschläge (Chips) ───────────────────────────────────────────────────
  modal.querySelectorAll('[data-search-suggestion]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var term = btn.getAttribute('data-search-suggestion') || '';
      if (input) { input.value = term; input.focus(); }
      syncClear();
      runSearch(term);
    });
  });

  // ── Clear-Button (X rechts im Input) ─────────────────────────────────────
  var clearBtn = modal.querySelector('[data-search-clear]');
  function syncClear() {
    if (!clearBtn) return;
    clearBtn.hidden = !(input && input.value.length); // nur sichtbar, wenn Text drin ist
  }
  if (clearBtn && input) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      syncClear();
      if (activeController) { activeController.abort(); activeController = null; }
      clearTimeout(debounceTimer);
      showState('empty');
      input.focus();
    });
  }

  // ── Eingabe ──────────────────────────────────────────────────────────────
  if (input) {
    input.addEventListener('input', function () {
      syncClear();
      var q = input.value.trim();
      clearTimeout(debounceTimer);
      if (q.length < 2) {
        if (activeController) { activeController.abort(); activeController = null; }
        showState('empty');
        return;
      }
      debounceTimer = setTimeout(function () { runSearch(q); }, 200);
    });

    // Enter → vollständige Suchergebnis-Seite (Fallback)
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        var q = input.value.trim();
        if (q.length) window.location.href = fullSearchUrl(q);
      }
    });
  }

  function fullSearchUrl(q) {
    return '/search?q=' + encodeURIComponent(q) + '&type=page,article&options[prefix]=last';
  }

  // ── Suche ausführen (Hybrid: Seiten lokal, Artikel via Shopify) ──────────
  function runSearch(q) {
    if (!q || q.length < 2) { showState('empty'); return; }
    showState('loading');

    if (activeController) activeController.abort();
    activeController = new AbortController();

    // Lokal & synchron: ganze Seiten (Titel-Match) + Section-Inhalte.
    var sites = searchSites(q);
    var pages = searchPages(q);
    // Section-Treffer, deren Seite schon als ganzer Seiten-Treffer oben steht,
    // raus — sonst erscheint die Seite doppelt (oben als Name, hier als Section).
    var siteUrls = {};
    sites.forEach(function (s) { siteUrls[s.url.split('#')[0]] = true; });
    pages = pages.filter(function (p) { return !siteUrls[p.url.split('#')[0]]; });

    // Artikel parallel über Shopify-Volltext holen (nur Magazin).
    var url = '/search'
      + '?q=' + encodeURIComponent(q)
      + '&type=article'
      + '&options[prefix]=last'
      + '&view=suggest-content';

    fetch(url, { signal: activeController.signal, headers: { 'Accept': 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        renderResults(sites, pages, (data && data.articles) || [], q);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        // Artikel-Fetch fehlgeschlagen → wenigstens die lokalen Treffer zeigen.
        renderResults(sites, pages, [], q);
      });
  }

  // ── Ganze Seiten/Produkte finden (→ Seiten-URL ohne Anker). Eigene "Seiten"-
  // Gruppe ganz oben: der Nutzer will primär ZUR Seite. Gematcht wird gegen
  // Titel, Handle (z.B. "faq" → Seite "Häufige Fragen") UND Aliase (z.B. "hilfe").
  function searchSites(q) {
    if (!sitePages || !sitePages.length) return [];
    var ql = q.toLowerCase().trim();
    var terms = ql.split(/\s+/).filter(Boolean);
    var out = [];
    for (var i = 0; i < sitePages.length; i++) {
      var pg = sitePages[i];
      if (pg.suffix === '__index__') continue;          // Startseite nicht als Namens-Treffer
      var titleLc = (pg.title || '').toLowerCase();
      var handleLc = (pg.handle || '').toLowerCase();
      var aliases = aliasByHandle[handleLc] || [];
      // Durchsuchbarer Text der Seite: Titel + Handle + Aliase.
      var hay = titleLc + ' ' + handleLc.replace(/-/g, ' ') + ' ' + aliases.join(' ');
      // Alle Suchwörter müssen irgendwo davon vorkommen.
      if (!terms.every(function (t) { return hay.indexOf(t) !== -1; })) continue;
      // Exakter Alias/Handle = kanonische Seite für diesen Begriff → hoch ranken,
      // damit z.B. "datenschutz" die Policy schlägt, nicht eine Seite, die das
      // Wort nur zufällig im Titel trägt.
      var exactAlias = (handleLc === ql || aliases.indexOf(ql) !== -1);
      var score = 0;
      if (titleLc === ql) score += 1000;
      else if (exactAlias) score += 900;
      else if (titleLc.indexOf(ql) === 0) score += 200;
      else score += 50;
      // Rechtliche/Compliance-Seiten (Impressum, AGB, Datenschutz, Widerruf …)
      // NUR bei einem starken, gezielten Treffer zeigen (exakter Titel/Alias/Handle
      // oder Titel-Anfang) — nie als loser Teilwort-Treffer. Schützt davor, dass
      // ein Senior/Angehöriger versehentlich ins Kleingedruckte geschickt wird.
      if (pg.legal && score < 200) continue;
      out.push({ title: pg.title, url: pg.url, score: score });
    }
    out.sort(function (a, b) { return b.score - a.score; });
    // Dedup nach Titel: bei mehreren Seiten mit demselben Namen (z.B. zwei
    // "Kostenerstattung"-Seiten als Inhalts-Duplikate im Shop) nur die
    // bestplatzierte zeigen, damit derselbe Name nicht doppelt erscheint.
    var seen = {}, deduped = [];
    out.forEach(function (o) {
      var key = o.title.trim().toLowerCase();
      if (!seen[key]) { seen[key] = true; deduped.push(o); }
    });
    return deduped.slice(0, 5);
  }

  // Kuratierte Pins: bei bestimmten Suchbegriffen einen passenden Content-Eintrag
  // ganz nach oben heben. matchTerms = wenn EINER dieser Begriffe im Query steckt,
  // textIncludes = den Eintrag erkennen (Teilstring im Eintrags-Text/Titel).
  var SEARCH_PINS = [
    {
      matchTerms: ['pflegegrad', 'pflegekasse'],
      textIncludes: 'kann die pflegekasse ihre monatlichen gardia kosten übernehmen',
      displayTitle: 'Kann die Pflegekasse Ihre monatlichen Gardia Kosten übernehmen?',
    },
  ];

  // ── Lokaler Volltext über den Seiten-Index (Section-Inhalte mit Deep-Link) ─
  function searchPages(q) {
    if (!pageIndex || !pageIndex.length) return [];
    var ql = q.toLowerCase().trim();
    var terms = ql.split(/\s+/).filter(Boolean);
    // Aktive Pins für diesen Query bestimmen.
    var activePins = SEARCH_PINS.filter(function (p) {
      return p.matchTerms.some(function (t) { return ql.indexOf(t) !== -1; });
    });
    var out = [];
    for (var i = 0; i < pageIndex.length; i++) {
      var entry = pageIndex[i];
      var pageLc = (entry.page || '').toLowerCase();   // Seitenname (z.B. "Kostenerstattung")
      var titleLc = (entry.title || '').toLowerCase(); // Section-/Frage-Titel
      var textLc = (entry.text || '').toLowerCase();
      var haystack = pageLc + ' ' + titleLc + ' ' + textLc;
      // Alle Wörter müssen irgendwo vorkommen (UND).
      var all = terms.every(function (t) { return haystack.indexOf(t) !== -1; });
      if (!all) continue;

      // Score — Seitenname > Section-Titel > Fließtext. Exakte/Anfangs-Matches extra.
      var score = 0;
      if (pageLc === ql) score += 1000;                 // Seitenname = exakt der Suchbegriff
      else if (pageLc.indexOf(ql) === 0) score += 200;  // Seitenname beginnt damit
      if (titleLc === ql) score += 150;
      else if (titleLc.indexOf(ql) === 0) score += 60;
      terms.forEach(function (t) {
        if (pageLc.indexOf(t) !== -1) score += 40;
        if (titleLc.indexOf(t) !== -1) score += 12;
        if (textLc.indexOf(t) !== -1) score += 1;
      });
      // Kuratierter Pin: passt der Eintrag zu einem aktiven Pin → ganz nach oben,
      // optional mit überschriebenem Anzeige-Titel (FAQ-Frage statt "Häufige Fragen.").
      var pinnedTitle = null;
      var matchedPin = activePins.find ? activePins.find(function (p) { return haystack.indexOf(p.textIncludes) !== -1; }) : null;
      if (!matchedPin) {
        for (var pi = 0; pi < activePins.length; pi++) {
          if (haystack.indexOf(activePins[pi].textIncludes) !== -1) { matchedPin = activePins[pi]; break; }
        }
      }
      if (matchedPin) {
        score += 100000;
        pinnedTitle = matchedPin.displayTitle || null;
      }

      out.push({
        title: pinnedTitle || entry.title || entry.page,
        page: entry.page || '',
        url: entry.url,
        snippet: makeSnippet(entry.text, terms),
        score: score,
      });
    }

    // Dedup pro Seite (gleicher Pfad ohne Hash) — nur der beste Treffer je Seite,
    // damit nicht 3× dieselbe Seite untereinander steht.
    out.sort(function (a, b) { return b.score - a.score; });
    var seen = {};
    var deduped = [];
    for (var j = 0; j < out.length; j++) {
      var path = out[j].url.split('#')[0];
      if (seen[path]) continue;
      seen[path] = true;
      deduped.push(out[j]);
    }
    return deduped.slice(0, 6);
  }

  // Schneidet ~140 Zeichen rund um den ersten Treffer aus und markiert die Begriffe.
  function makeSnippet(text, terms) {
    var lc = text.toLowerCase();
    var pos = -1;
    for (var i = 0; i < terms.length; i++) {
      var p = lc.indexOf(terms[i]);
      if (p !== -1 && (pos === -1 || p < pos)) pos = p;
    }
    if (pos === -1) pos = 0;
    var start = Math.max(0, pos - 50);
    var end = Math.min(text.length, pos + 110);
    var snip = (start > 0 ? '… ' : '') + text.slice(start, end).trim() + (end < text.length ? ' …' : '');
    // Reinen Text zurückgeben — das Markieren der Suchbegriffe übernimmt
    // setSnippet() nach dem HTML-Escapen (sicher gegen Injection).
    return snip;
  }

  // ── Ergebnisse rendern ───────────────────────────────────────────────────
  function renderResults(sites, pages, articles, q) {
    sitesEl.innerHTML = '';
    pagesEl.innerHTML = '';
    articlesEl.innerHTML = '';

    var terms = termsOf(q);

    // Seiten — ganze Seiten/Produkte (Titel → Seiten-URL), ganz oben
    if (sites.length) {
      sites.forEach(function (s) { sitesEl.appendChild(siteRow(s)); });
      sitesGroup.style.display = '';
    } else {
      sitesGroup.style.display = 'none';
    }

    // Auf den Seiten gefunden — Section-Treffer mit Snippet + Deep-Link
    if (pages.length) {
      pages.forEach(function (p) { pagesEl.appendChild(pageRow(p, terms)); });
      pagesGroup.style.display = '';
    } else {
      pagesGroup.style.display = 'none';
    }

    // Magazin — kompakte Titel-Liste, limitiert
    if (articles.length) {
      articles.slice(0, ARTICLE_LIMIT).forEach(function (a) {
        articlesEl.appendChild(articleRow(a, terms));
      });
      if (allLink) allLink.setAttribute('href', fullSearchUrl(q));
      articlesGroup.style.display = '';
    } else {
      articlesGroup.style.display = 'none';
    }

    showState(sites.length || pages.length || articles.length ? 'results' : 'noresults');
  }

  // Kompakte Zeile für eine ganze Seite/Produkt: Icon + Titel → Seiten-URL.
  function siteRow(s) {
    var a = document.createElement('a');
    a.href = s.url;
    a.className = 'flex items-center gap-3 -mx-2 px-2 py-2.5 rounded-xl hover:bg-slate-50 transition-colors no-underline';
    a.innerHTML =
      '<span class="shrink-0 w-9 h-9 flex items-center justify-center rounded-lg bg-slate-100 text-blue-950">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
          '<path d="M6 3h8l4 4v14H6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
          '<path d="M14 3v4h4M9 13h6M9 17h6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
        '</svg>' +
      '</span>';
    var title = document.createElement('span');
    title.className = 'body-text-sm font-semibold text-blue-950';
    title.textContent = s.title;
    a.appendChild(title);
    return a;
  }

  // Prominente Zeile für Seiten: Icon + Titel + Kontext-Snippet (mit Highlight)
  function pageRow(p, terms) {
    var a = document.createElement('a');
    a.href = p.url;
    a.className = 'flex items-start gap-3 -mx-2 px-2 py-2.5 rounded-xl hover:bg-slate-50 transition-colors no-underline';

    var icon = document.createElement('span');
    icon.className = 'shrink-0 w-9 h-9 mt-0.5 flex items-center justify-center rounded-lg bg-slate-100 text-blue-950';
    icon.innerHTML =
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
        '<path d="M6 3h8l4 4v14H6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
        '<path d="M14 3v4h4M9 13h6M9 17h6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
      '</svg>';

    var text = document.createElement('span');
    text.className = 'flex flex-col gap-0.5 min-w-0';
    var title = document.createElement('span');
    title.className = 'body-text-sm font-semibold text-blue-950';
    title.textContent = p.title;
    text.appendChild(title);
    // Übergeordnete Seite als Breadcrumb (nur wenn sie sich vom Titel unterscheidet —
    // bei FAQ ist Titel = Frage, page = "Häufige Fragen", also sinnvoll).
    if (p.page && p.page !== p.title) {
      var crumb = document.createElement('span');
      crumb.className = 'text-[11px] font-medium text-slate-400';
      crumb.textContent = p.page;
      text.appendChild(crumb);
    }
    if (p.snippet) {
      var snip = document.createElement('span');
      snip.className = 'pi-search-snippet text-[13px] leading-snug text-slate-500';
      setSnippet(snip, p.snippet, terms);
      text.appendChild(snip);
    }

    a.appendChild(icon);
    a.appendChild(text);
    return a;
  }

  // Kompakte Zeile fürs Magazin: Titel + Kontext-Snippet (mit Highlight)
  function articleRow(a, terms) {
    var el = document.createElement('a');
    el.href = a.url;
    el.className = 'block py-2.5 no-underline group';
    var title = document.createElement('span');
    title.className = 'block body-text-sm font-medium text-blue-950 group-hover:text-teal-600 transition-colors';
    title.textContent = a.title;
    el.appendChild(title);
    if (a.snippet) {
      var snip = document.createElement('span');
      snip.className = 'pi-search-snippet block mt-0.5 text-[13px] leading-snug text-slate-500';
      setSnippet(snip, a.snippet, terms);
      el.appendChild(snip);
    }
    return el;
  }

  // Snippet sicher rendern: erst HTML escapen, dann Highlights setzen.
  //  - Shopify-Snippets (Artikel) enthalten <strong class="highlight"> → zu <mark>.
  //  - Lokale Snippets (Seiten) sind reiner Text → übergebene terms markieren.
  function setSnippet(el, raw, terms) {
    var safe = escapeHtml(raw)
      .replace(/&lt;strong class=&quot;highlight&quot;&gt;/g, '<mark>')
      .replace(/&lt;strong class="highlight"&gt;/g, '<mark>')
      .replace(/&lt;mark&gt;/g, '<mark>')
      .replace(/&lt;\/strong&gt;/g, '</mark>')
      .replace(/&lt;\/mark&gt;/g, '</mark>');
    if (terms && terms.length && safe.indexOf('<mark>') === -1) {
      terms.slice().sort(function (a, b) { return b.length - a.length; }).forEach(function (t) {
        if (!t) return;
        var re = new RegExp('(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
        safe = safe.replace(re, '<mark>$1</mark>');
      });
    }
    el.innerHTML = safe;
  }

  function termsOf(q) {
    return (q || '').toLowerCase().split(/\s+/).filter(Boolean);
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str == null ? '' : str;
    return d.innerHTML;
  }
})();
